import actionTypes from './formSummary.actionTypes';

const initialState = {
  isLoading: true,
  summaryData: {},
  companyId: '',
  employeeId: '',
  formInstanceGuid: '',
  includeParticipants: true,
  viewConfidentially: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_SUMMARY_QUESTIONS_BEGIN: return fetchSummaryQuestionsBegin(state, action);
    case actionTypes.FETCH_SUMMARY_QUESTIONS_SUCCESS: return fetchSummaryQuestionsSuccess(state, action);
    case actionTypes.FETCH_SUMMARY_QUESTIONS_FAILURE: return fetchSummaryQuestionsFailure(state);

    default:
      return state;
  }
}

const fetchSummaryQuestionsBegin = (state, { payload }) => {
  return {
    ...state,
    isLoading: true
  };
};

const fetchSummaryQuestionsSuccess = (state, action) => {
  let summaryData = action.data;
  return {
    ...state,
    isLoading: false,
    summaryData: summaryData,
  };
};

const fetchSummaryQuestionsFailure = state => {
  return {
    ...state,
    isLoading: false
  };
};
